  <div fxLayout="column" *ngIf="pathNames">
    <mat-label id="path" [style.font-size.em]="0.8" [style.white-space]="'nowrap'">
      {{pathNames.slice(1, pathNames.length - 1).join(' > ')}}
    </mat-label>
    <mat-label id="code">{{pathNames[pathNames.length - 1]}}</mat-label>
  </div>
